var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5576 0.250204C27.8446 0.0862413 28.1695 0 28.5 0C28.8305 0 29.1554 0.0862413 29.4424 0.250204L56.0424 15.4512C56.3332 15.6174 56.5749 15.8574 56.7431 16.147C56.9113 16.4367 56.9999 16.7656 57 17.1006V19.8367C57.0001 28.22 54.2692 36.3751 49.2208 43.0675C44.1723 49.76 37.0811 54.6254 29.0206 56.9273C28.6803 57.0242 28.3197 57.0242 27.9794 56.9273C19.9195 54.6243 12.829 49.7586 7.78077 43.0664C2.73249 36.3742 0.00114131 28.2197 0 19.8367L0 17.1006C0.000108023 16.7656 0.0887348 16.4367 0.256901 16.147C0.425067 15.8574 0.666797 15.6174 0.9576 15.4512L27.5576 0.250204ZM26.8736 40.704L43.282 20.1864L40.318 17.815L26.3264 35.3L16.416 27.042L13.984 29.9606L26.8736 40.704Z",
    fill: "#0FA958"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.bbe5a19e189e95a9b67dca73a1d42e9d.svg";
export { ForwardRef as ReactComponent };